import React, { createContext, useContext } from 'react';
import FileUploaded from '~/components/FileUploaded';
import { PLACEHOLDER_IMAGE } from '~/config/constants';
import PropTypes from 'prop-types';
//Ref: https://blog.openreplay.com/the-transition-from-higher-order-component-pattern-to-react-hooks-pattern/

const WithCustomPreviewContext = createContext();
export const useWithCustomPreviewContext = () => useContext(WithCustomPreviewContext);

const withCustomPreview = (CustomPreview) => {
    function FileUploadedWithCustomPreview({
        pictureName,
        pictureVal,
        resetCount,
        formFileClass,
        width,
        height,
        minWidth,
        maxWidth,
        heightWrapper,
        wrapperClass,
        wrapperStyle,
    }) {
        const [tempUrl, setTempUrl] = React.useState(pictureVal);
        const pictureUrl = tempUrl || PLACEHOLDER_IMAGE;

        const inputEl = React.useRef(null);

        React.useEffect(() => {
            setTempUrl(pictureVal);
        }, [resetCount]);

        return (
            <WithCustomPreviewContext.Provider
                value={{
                    pictureUrl,
                    inputEl,
                    width,
                    height,
                    minWidth,
                    maxWidth,
                    heightWrapper,
                    pictureName,
                    wrapperClass,
                    wrapperStyle,
                }}
            >
                <FileUploaded
                    pictureName={pictureName}
                    setTempUrl={setTempUrl}
                    inputEl={inputEl}
                    formFileClass={formFileClass}
                >
                    <FileUploaded.Preview>
                        <CustomPreview />
                    </FileUploaded.Preview>
                </FileUploaded>
            </WithCustomPreviewContext.Provider>
        );
    }

    FileUploadedWithCustomPreview.defaultProps = {
        resetCount: 0,
        previewComponent: null,
        formFileClass: '',
        width: '',
        height: '',
        minWidth: '',
        maxWidth: '',
        heightWrapper: '',
        wrapperClass: '',
        wrapperStyle: {},
    };

    FileUploadedWithCustomPreview.propTypes = {
        pictureName: PropTypes.string.isRequired,
        pictureVal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, //PropTypes.object is when uploading new pic.
        resetCount: PropTypes.number,
        formFileClass: PropTypes.string,
        previewComponent: PropTypes.func,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        heightWrapper: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        wrapperClass: PropTypes.string,
        wrapperStyle: PropTypes.object,
    };

    return React.memo(FileUploadedWithCustomPreview);
};

export default withCustomPreview;
